export class Item {
  item:string;
  description:string;
  location:any;
  town:any;
  category:any;
  subcategory:any;
  value:any;
  userId:any;
  constructor() {}
}
